import {AfterViewInit, Component, OnInit, SecurityContext} from '@angular/core';

import {language} from '../../language/vn';
import {ThuService} from '../../service/email/service-thu';
import {FormBuilder} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {BsModalService} from 'ngx-bootstrap/modal';
import {Sessioncommand} from '../../global/sessioncommand';
import {Thu} from '../../models/email/thu';
import {ToTrinhXuLy} from '../../models/totrinh/totrinhxuly';
import {YeuCauXuLy} from '../../models/yeucau/yeucauxuly';
import {ToTrinhXuLyService} from '../../service/totrinh/service-totrinhxuly';
import {YeuCauXuLyService} from '../../service/yeucau/service-yeucauxuly';
import {VanBanDen} from '../../models/vanbanden/vanbanden';
import {VanBanDenService} from '../../service/vanbanden/service-vanbanden';
import {VanBanDi} from '../../models/vanbandi/vanbandi';
import {VanBanDiService} from '../../service/vanbandi/service-vanbandi';
import {environment} from '../../../environments/environment';
import {XuLyTongHopToTrinhComponent} from '../../views/info/giaiquyetsuvu/xuly/xuly.component';
import {XuLyThuComponent} from '../../views/info/email/xuly/xuly.component';
import {XuLyTongHopVanBanDenComponent} from '../../views/info/vanbanden/xuly/xuly.component';
import {XuLyTongHopVanBanDiComponent} from '../../views/info/vanbandi/xuly/xuly.component';
import {XuLyTongHopYeuCauComponent} from '../../views/info/giaiquyetsuvu/xuly/yeucau.component';
import {ProfileStaffsComponent} from '../../views/info/users/profile.component';
import {ChangePasswordComponent} from '../../views/info/users/password.component';
import {Router} from '@angular/router';
import {ChatComponent} from '../../views/info/chat/chat.component';
import {DomSanitizer} from '@angular/platform-browser';
import {WebSocketService} from '../../service/chat/websocket-service';
import {DatePipe} from '@angular/common';
import {interval, timer} from 'rxjs';
import {tryCatch} from 'rxjs/internal-compatibility';
import {StaffsService} from '../../service/staff/service-staffs';
import {CommandUtil} from '../../global/commandutil';
import {NavItemService} from '../../service/staff/service-navitem';
import {NavItem} from '../../models/staff/navitem';
import {INavData} from '@coreui/angular';
import {take} from 'rxjs/operators';
import {navItems} from '../../_nav';
import {CalendarNews} from '../../models/calendar/calendarnews';
import {CalendarNewsService} from '../../service/calendar/service-calendarnews';
import {HoSoService} from '../../service/hoso/service-hoso';
import {HoSo} from '../../models/hoso/hoso';
import {DetailHoSoComponent} from '../../views/info/hoso/canhan/detail.component';
import {ThongBaoService} from '../../service/info/service-thongbao';
import {ThongBao} from '../../models/info/thongbao';
import {ReadThongBaoComponent} from '../../views/info/thongbao/read.component';
import {ConfigAlertComponent} from '../../views/info/configalert/configalert.component';
import {ReadLichCongTacComponent} from '../../views/info/lichcongtac/readlichcongtac.component';
import {HoTroService} from '../../service/log/service-hotro';
import {HoTro} from '../../models/log/hotro';
import {AlertThongTinComponent} from '../../views/info/users/alert.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent implements OnInit, AfterViewInit{
  public sidebarMinimized = false;
  public classAppHeader: string = 'animated fadeOut';
  public navItems: INavData[] =[] ;
  public language = language;
  public dataEmail: Thu[] =[];
  public dataToTrinhNhan:  ToTrinhXuLy[]= [];
  public dataYeuCauNhan: YeuCauXuLy[] =[];
  public dataVanBanDenXuLy: VanBanDen[] = [];
  public dataVanBanDiXuLy: VanBanDi[] =[];
  public dataLichCongTac: CalendarNews[] = [];
  public dataThongBao: ThongBao[] =[];
  public hoTroList: HoTro[] = [];
  public dataHoSo: HoSo[] = [];
  public currentPage: number =1;
  public pageSize: number =10;
  public staffAvatar: String = 'assets/img/avatars/6.jpg';
  html: string = '';
  public stompClient: any ;
  public receiveUrl: string= environment.chatReceiveUrl;
  public sendUrl: string= environment.chatSendUrl;
  public addUrl: string= environment.chatAddUrl;
  public sessionChat: String = 'notification' ;
  public refNote: number = 0;
  public emailStatus: string = '1,2';
  constructor(
    public thuService: ThuService,
    public toTrinhXuLyService: ToTrinhXuLyService,
    public yeuCauXuLyService: YeuCauXuLyService,
    public vanBanDenService: VanBanDenService,
    public vanBanDiService: VanBanDiService,
    public bsModalService: BsModalService,
    public router: Router,
    public thongBaoService: ThongBaoService,
    public sanitizer: DomSanitizer,
    public webSocketService: WebSocketService,
    public staffsService: StaffsService,
    public commandUtil: CommandUtil,
    public navItemService: NavItemService,
    public calendarNewService: CalendarNewsService,
    public datePipe: DatePipe,
    public  hoSoService: HoSoService,
    public hoTroService: HoTroService
  ) {


  }
  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }
   ngOnInit(): void{
    this.load();
    this.connectNotification();
    this.staffsService.getById(Sessioncommand.staffId).subscribe(dt => {
      if (dt.anh !== null && dt.anh !== '')
        this.staffAvatar= this.commandUtil.getUrlAvatar(dt.anh);
    });
   this.loadNav();
   this.hoTroService.findAll().subscribe( data => this.hoTroList = data);
  }
  public loadNav()
  {
    this.navItemService.findALlByStaffId(Sessioncommand.staffId, 0, true).subscribe( x =>{
      let navParent:  NavItem[] = x.filter( k => k.parentId ===0);
      this.navItems = [];
      this.navItems.push({
        name: language.home,
        url: '/',
        icon: 'fa fa-home'
      });
      for(let i =0; i< navParent.length; i++)
      {
        let navChild: NavItem[] = x.filter( t => t.parentId == navParent[i].id);
        let navItemChild: INavData[] = [];
        for( let s=0; s< navChild.length ; s++)
        {
          navItemChild.push({
            name: navChild[s].name,
            url: navChild[s].url,
            icon: navChild[s].icon
          });
        }
        if(navItemChild.length>0) {
          this.navItems.push({
            name: navParent[i].name,
            url: navParent[i].url,
            icon: navParent[i].icon,
            children: navItemChild
          });
        }else
        {
          this.navItems.push({
            name: navParent[i].name,
            url: navParent[i].url,
            icon: navParent[i].icon
          });
        }
      }
    });
  }
  ngAfterViewInit(): void {

    interval(10000).subscribe((func => {
      this.send();
    }));
    interval(3000).subscribe((func => {
      if(document.getElementById("refNote").getAttribute("value" )== "1")
        this.load();
    }));
    setInterval(() => {
      if (Sessioncommand.sideBarActive === true ) {
        this.sidebarMinimized = true;
        Sessioncommand.sideBarActive = false;
      }
    }, 1000);
  }

  public connectNotification() {
    try {
      this.stompClient = this.webSocketService.connect();
      this.stompClient.connect({}, frame => {
        this.stompClient.subscribe(this.receiveUrl + this.sessionChat, this.onMessageReceived);
      });
      this.stompClient.send(this.addUrl + this.sessionChat, {}, JSON.stringify({
        sender: Sessioncommand.userId,
        sessionChat: this.sessionChat,
        type: 'JOIN'
      }));
    }catch (e) {
      console.log(e.toString());
    }
  }
  public send() {

    if(Sessioncommand.notification == true) {
      let bodyMessage: Object = {
        sender: Sessioncommand.userId,
        sessionChat: this.sessionChat,
        content: 'alert-message-' + Sessioncommand.userId,
        type: 'CHAT',
        fullName: Sessioncommand.staffId,
        name: 'Message'
      };

      this.stompClient.send(this.sendUrl + this.sessionChat, {}, JSON.stringify(bodyMessage));
      Sessioncommand.notification= false;
    }
  }
  public onMessageReceived(message)
  {
    document.getElementById("refNote").setAttribute("value", "1");
  }
  public load()
  {
    this.thuService.findAllByPaging('', Sessioncommand.staffId, 0, 0, this.emailStatus , this.currentPage, this.pageSize).subscribe(dataList => this.dataEmail = dataList);
    this.toTrinhXuLyService.findAllByPaging('', '1,2,3', Sessioncommand.staffId, 0,'','', this.currentPage, this.pageSize).subscribe(dataList => this.dataToTrinhNhan = dataList);
    this.yeuCauXuLyService.findAllByPaging('', '1,2,3', Sessioncommand.staffId, 0, '', '', this.currentPage, this.pageSize).subscribe(dataList => this.dataYeuCauNhan = dataList);
    this.vanBanDenService.findAllByXLPaging('', -1, -1, environment.chuaxuly.toString(), -1, Sessioncommand.staffId, -1,
      -1, 0, '','',this.currentPage, this.pageSize).subscribe(dataList => this.dataVanBanDenXuLy = dataList);
    this.vanBanDiService.findAllByXLPaging('', -1,-1,  environment.chuaxuly.toString(), -1,
      Sessioncommand.staffId, -1,0,'','', this.currentPage, this.pageSize).subscribe(dataList => this.dataVanBanDiXuLy = dataList);
    document.getElementById("refNote").setAttribute("value", "0");
    this.calendarNewService.findByStaffId(Sessioncommand.staffId, -1, -1).subscribe( dataList => this.dataLichCongTac= dataList);
    this.hoSoService.findAllByShare("-1", Sessioncommand.staffId).subscribe( dataList => this.dataHoSo = dataList);
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,"0001", true).subscribe(
      x => {
        this.thongBaoService.findAllByAlert(Sessioncommand.staffId, (x > 0 ? -1 : Sessioncommand.staffId)).subscribe( dt => this.dataThongBao = dt);

      }
    );

  }
  public xuLyToTrinh(id: number) {
    const modalEdit = this.bsModalService.show(XuLyTongHopToTrinhComponent, {class: 'modal-lg'});
    (<XuLyTongHopToTrinhComponent>modalEdit.content).edit(
      id, true
    );
    (<XuLyTongHopToTrinhComponent>modalEdit.content).onClose.subscribe(result => {
      this.toTrinhXuLyService.findAllByPaging('', '-1', Sessioncommand.staffId, 0,'','', this.currentPage, this.pageSize).subscribe(dataList => this.dataToTrinhNhan = dataList);
    });

  }
  public xuLyThu(id: number) {
    const modalEdit = this.bsModalService.show(XuLyThuComponent, {class: 'modal-lg'});
    (<XuLyThuComponent>modalEdit.content).edit(
      id
    );
    (<XuLyThuComponent>modalEdit.content).onClose.subscribe(result => {
      this.thuService.findAllByPaging('', Sessioncommand.staffId, 0, 0, this.emailStatus,  this.currentPage, this.pageSize).subscribe(dataList => this.dataEmail = dataList);
    });

  }
  public xuLyVBDen(id: number) {
    const modalEdit = this.bsModalService.show(XuLyTongHopVanBanDenComponent, {class: 'modal-lg'});
    (<XuLyTongHopVanBanDenComponent>modalEdit.content).edit(
      id, true
    );
    (<XuLyTongHopVanBanDenComponent>modalEdit.content).onClose.subscribe(result => {
      this.vanBanDenService.findAllByXLPaging('', -1, -1, environment.chuaxuly.toString(), -1, Sessioncommand.staffId, -1,
        -1, 0,'','', this.currentPage, this.pageSize).subscribe(dataList => this.dataVanBanDenXuLy = dataList);
    });

  }
  public viewCongTac(id: number) {
    const modalEdit = this.bsModalService.show(ReadLichCongTacComponent, {class: 'modal-lg'});
    (<ReadLichCongTacComponent>modalEdit.content).edit(
      id
    );
    (<ReadLichCongTacComponent>modalEdit.content).onClose.subscribe(result => {
      this.calendarNewService.findByStaffId(Sessioncommand.staffId, -1, -1).subscribe( dataList => this.dataLichCongTac= dataList);
    });

  }
  public viewHoSo(id: number) {
    const modalEdit = this.bsModalService.show(DetailHoSoComponent, {class: 'modal-lg'});
    (<DetailHoSoComponent>modalEdit.content).edit(
      id
    );
    (<DetailHoSoComponent>modalEdit.content).onClose.subscribe(result => {
      this.hoSoService.findAllByShare("-1", Sessioncommand.staffId).subscribe( dataList => this.dataHoSo= dataList);
    });
  }
  docThongBao(id: number) {
    const modalEdit = this.bsModalService.show(ReadThongBaoComponent, {class: 'modal-lg'});
    (<ReadThongBaoComponent>modalEdit.content).edit(
      id
    );
    (<ReadThongBaoComponent>modalEdit.content).onClose.subscribe(result => {
      this.navItemService.checkPermissionByCode(Sessioncommand.staffId,"0001", true).subscribe(
        x => {
          this.thongBaoService.findAllByAlert(Sessioncommand.staffId, (x > 0 ? -1 : Sessioncommand.staffId)).subscribe( dt => this.dataThongBao = dt);

        }
      );
    });
  }
  public xuLyVBDi(id: number) {
    const modalEdit = this.bsModalService.show(XuLyTongHopVanBanDiComponent, {class: 'modal-lg'});
    (<XuLyTongHopVanBanDiComponent>modalEdit.content).edit(
      id, true
    );
    (<XuLyTongHopVanBanDiComponent>modalEdit.content).onClose.subscribe(result => {
      this.vanBanDiService.findAllByXLPaging('', -1,-1, environment.chuaxuly.toString(), -1,
        Sessioncommand.staffId, -1,0, '','',this.currentPage, this.pageSize).subscribe(dataList => this.dataVanBanDiXuLy = dataList);
    });

  }
  public xuLyYeuCau(id: number) {
    const modalEdit = this.bsModalService.show(XuLyTongHopYeuCauComponent, {class: 'modal-lg'});
    (<XuLyTongHopYeuCauComponent>modalEdit.content).edit(id, true);
    (<XuLyTongHopYeuCauComponent>modalEdit.content).onClose.subscribe(result => {
      this.yeuCauXuLyService.findAllByPaging('', '-1', Sessioncommand.staffId, 0,'','', this.currentPage, this.pageSize).subscribe(dataList => this.dataYeuCauNhan = dataList);
    });

  }
  public canhBao() {
    const modalEdit = this.bsModalService.show(AlertThongTinComponent, {class: 'modal-lg'});
    (<AlertThongTinComponent>modalEdit.content).show();

  }
  public profile() {
    const modalEdit = this.bsModalService.show(ProfileStaffsComponent, {class: 'modal-lg'});
    (<ProfileStaffsComponent>modalEdit.content).edit(
      Sessioncommand.staffId
    );
    (<ProfileStaffsComponent>modalEdit.content).onClose.subscribe(result => {

    });

  }

  public changePassword() {
    const modalEdit = this.bsModalService.show(ChangePasswordComponent);
    (<ChangePasswordComponent>modalEdit.content).edit(
      Sessioncommand.userId
    );
    (<ChangePasswordComponent>modalEdit.content).onClose.subscribe(result => {

    });

  }
  public configAlert() {
    const modalEdit = this.bsModalService.show(ConfigAlertComponent, {class: 'modal-lg'});
    (<ConfigAlertComponent>modalEdit.content).edit(
    );
    (<ConfigAlertComponent>modalEdit.content).onClose.subscribe(result => {

    });

  }

  public exit() {
    sessionStorage.setItem('userId', null);
    sessionStorage.setItem('token', null);
    sessionStorage.setItem('staffId', null);
    sessionStorage.setItem('maDonVi', null);
    this.router.navigate(['login']);
  }
}

